import template from './overdueByContractModal.html';
import controller from './overdueByContractModal.controller';

let OverdueByContractModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-warning animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
OverdueByContractModalComponent.template = template;
OverdueByContractModalComponent.controller = controller;

export default OverdueByContractModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/OverdueByContractModal/overdueByContractModal.component.js